module.exports = __webpack_public_path__ + "static/img/Canoe-Selected.1e11595.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/destinations/Canoe-Selected.png
// module id = 602
// module chunks = 0